import script from "./KpiMiniCard.vue?vue&type=script&setup=true&lang=js"
export * from "./KpiMiniCard.vue?vue&type=script&setup=true&lang=js"

import "./KpiMiniCard.vue?vue&type=style&index=0&id=63054d7b&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63054d7b"]])

export default __exports__